import { menuDesktop, triggerSearchOnClick, menuMobile } from './header/menu.js';
import { homePage } from './pages/homepage.js';
import { produit } from './pages/produit.js';
import { search } from './pages/search.js';
import { inspirations } from './pages/inspirations.js';
import { login } from './pages/login.js';
import { register } from './pages/register.js';
import { infiniteLoader } from './helpers/infiniteLoader.js';
import { gmaps } from './helpers/gmaps.js';
import { gmaps_relay } from './helpers/gmaps_relay.js';
import { contact } from './pages/contact.js';
import { documentations } from './pages/documentations.js';
import { checkout } from './pages/checkout.js';
import { modelisations } from './pages/modelisations.js';
import { myaccount } from './pages/myaccount.js';

$(document).ready(function() {

  $('#sitePreloader').addClass('remove');

  /**
   * MENU
   */
  menuMobile();
  menuDesktop();

  homePage();
  search();
  inspirations();
  produit();
  login();
  register();
  contact();
  checkout();
  modelisations();
  myaccount();

  if ($('body').hasClass('page-template-template-documentations')) {
    documentations();
  }

  if ($('#map').length) {
    gmaps();
  }

  if ($('#map_relay').length) {
    gmaps_relay();
  }

  if ($('.infinite-scroll-content').length) {
    infiniteLoader();
  }

  //DEV : TODO CLEAN
  $('.linkSelect').change(function() {
    var url = $(this).val(); // get selected value
    if (url) { // require a URL
        window.location = url; // redirect
    }
    return false;
  });

  // Back to top button.
  $(window).on('scroll', function () {
    if ($(this).scrollTop() == 0) {
      $('#back-to-top').css('display', 'none');
    }
    else if ($(this).scrollTop() > 150) {
      $('#back-to-top').css('display', 'block');
    }

    if (window.scrollMaxY - $('#colophon').height() < $(this).scrollTop()) {
      $('#back-to-top').css('color', '#FFFFFF');
      $('#back-to-top svg .st0').css('fill', '#FFFFFF');
      $('#back-to-top svg .st1').css('fill', '#004692');
      $('#back-to-top svg .st1').css('stroke', '#004692');
    }
    else {
      $('#back-to-top').css('color', '#004692');
      $('#back-to-top svg .st0').css('fill', '#004692');
      $('#back-to-top svg .st1').css('fill', '#FFFFFF');
      $('#back-to-top svg .st1').css('stroke', '#FFFFFF');
    }
  });

  $('#back-to-top').on('click', function () {
    $(window).scrollTop(0);
  });
})
